import React from 'react';

const LegalTermsLink = () => {
  const openLegalTerms = () => {
    // Abrir el documento legal en una nueva ventana/pestaña
    window.open('/legal/terms-and-conditions.html', '_blank');
  };
  
  return (
    <span 
      className="text-[#e31837] underline ml-1 cursor-pointer" 
      onClick={openLegalTerms}
    >
      condiciones de uso, política de privacidad y aviso legal
    </span>
  );
};

export default LegalTermsLink;